import {
  DETAIL_TRANSFER_SALES,
  DETAIL_TRANSFER_SALES_ERROR,
  CLEAN_DETAIL_TRANSFER_SALES,
  CLEAN_DETAIL_TRANSFER_SALES_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function detailTransferSalesReducer(state = initialState, action) {
  switch (action.type) {
    case DETAIL_TRANSFER_SALES:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case DETAIL_TRANSFER_SALES_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DETAIL_TRANSFER_SALES:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DETAIL_TRANSFER_SALES_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
